module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1043-1695b1ccf7325a69b8e6733d49efbac1.png";